<template>
  <div class="page-button">
    <PromoButton @click="handleClick">
      {{ $t("page.button") }}
    </PromoButton>
  </div>
</template>
<script>
import PromoButton from "@static_promo_pages/common/components/promo-button/vue/PromoButton";
import OneLinkSendEventsMixin from "@static_promo_pages/common/mixins/onelink/OneLinkSendEventsMixin";

export default {
  name: "ThePageButton",
  components: {
    PromoButton,
  },
  mixins: [OneLinkSendEventsMixin],
  mounted() {
    this.sendImpression();
  },
  methods: {
    handleClick() {
      this.sendClick();
      this.$emit("click");
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../styles/the-page-button";
</style>
